export default __webpack_public_path__ + "static/media/graphic3.8296bc0f.svg";